// Which screen the public /pay/:token page shows.
export const PAY_STATES = {
  LOADING: 'loading',
  PAYABLE: 'payable',
  PROCESSING: 'processing',
  PAID: 'paid',
  PLAN_ACTIVE: 'plan_active',
  UNAVAILABLE: 'unavailable',
  INVALID: 'invalid',
  RATE_LIMITED: 'rate_limited',
  ERROR: 'error',
};

export const payStateForInvoice = (invoice) => {
  // Nothing left to charge (e.g. fully credited) — never payable, whatever
  // the status says.
  if (invoice && Number(invoice.total) <= 0) return PAY_STATES.UNAVAILABLE;
  switch (invoice?.status) {
    case 'sent':
    case 'overdue':
      return PAY_STATES.PAYABLE;
    case 'processing':
      return PAY_STATES.PROCESSING;
    case 'paid':
      return PAY_STATES.PAID;
    case 'plan_active':
      return PAY_STATES.PLAN_ACTIVE;
    default:
      return PAY_STATES.UNAVAILABLE;
  }
};

export const payStateForError = (err) => {
  const status = err?.response?.status;
  if (status === 404) return PAY_STATES.INVALID;
  if (status === 429) return PAY_STATES.RATE_LIMITED;
  // The pay-intent endpoint returns 422 when there is no amount due to
  // charge (e.g. the invoice was credited between page load and payment).
  if (status === 422) return PAY_STATES.UNAVAILABLE;
  const invoice = err?.response?.data?.invoice;
  if (status === 409 && invoice) return payStateForInvoice(invoice);
  return PAY_STATES.ERROR;
};
